import React from 'react';
import { EditClient } from '../Components/Clients/EditClient';
import { ClientSecondaryEmails } from '../Components/Clients/ClientSecondaryEmails';
import { ClientSmsHistory } from '../Components/Clients/ClientSmsHistory';
import { useAppSelector } from '../hooks';

export const ClientDetails = () => {
  const selectedClientId = useAppSelector((state) => state.clients.selectedClientId);

  return (
    <>
      <EditClient />
      <ClientSecondaryEmails />
      {selectedClientId && <ClientSmsHistory clientId={selectedClientId} />}
    </>
  );
};
